import { Skeleton } from 'antd';
import { FC, useMemo } from 'react';
import ErrorBox from 'components/ErrorBox';
import { useBrokerList } from 'modules/Transfer/hooks';
import { otherBrokerOption } from 'modules/Transfer/modules/Steps/helper';
import { BrokerIdType } from 'modules/Transfer/type';
import style from './style.scss';

export interface BrokerInfoProps {
    data: {
        brokerId: BrokerIdType;
        holderName: string;
        account: string;
    };
}

const BrokerInfo: FC<BrokerInfoProps> = ({ data }) => {
    const {
        data: brokerListData,
        error: brokerListError,
        isLoading: brokerListLoading,
        mutate: BrokerListMutate
    } = useBrokerList({ getAllBroker: true });

    const brokerInfo = useMemo(() => {
        const brokerList = (brokerListData?.items || []).concat(otherBrokerOption);

        // 如果没有从接口中找到对应的brokerId，则也认为是other经济商
        return brokerList.find(item => item.id === data.brokerId) || otherBrokerOption;
    }, [brokerListData, data]);

    if (brokerListError && !brokerListData) {
        return <ErrorBox error={brokerListError} onClick={() => BrokerListMutate()} />;
    }

    if (brokerListLoading) {
        return <Skeleton active avatar title={false} paragraph={{ rows: 2 }} />;
    }

    return (
        <div className={style.brokerInfo}>
            <div className={style.brokerLogo} style={{ backgroundImage: `url("${brokerInfo.logo}")` }}></div>
            <div className={style.brokerData}>
                <div className={style.brokerName}>{brokerInfo.broker}</div>
                <div className={style.brokerAccount}>{`${data.holderName} / ${data.account}`}</div>
            </div>
        </div>
    );
};

export default BrokerInfo;
